module.exports = __webpack_public_path__ + "img/icon-pdf.cdd77190.svg";